<template>
    <!-- "Rows per page: 20 ⌄" of the merchant portal's Transactions footer: a text toggle whose
         menu opens upwards (tasks#211) -->
    <div class="dd-per-page">
        <span class="dd-per-page__label">{{
            $vuetify.lang.t('$vuetify.dataTable.itemsPerPageText')
        }}</span>
        <v-menu top left offset-y nudge-top="4" content-class="dd-filter-menu">
            <template #activator="{ on, attrs }">
                <button
                    type="button"
                    class="dd-per-page__toggle"
                    v-bind="attrs"
                    v-on="on"
                >
                    {{ value }}
                    <v-icon>expand_more</v-icon>
                </button>
            </template>
            <div class="dd-per-page__items" role="menu">
                <button
                    v-for="choice in choices"
                    :key="choice"
                    type="button"
                    role="menuitemradio"
                    :aria-checked="String(choice === value)"
                    :class="[
                        'dd-option',
                        { 'dd-option--selected': choice === value },
                    ]"
                    @click="$emit('input', choice)"
                >
                    {{ choice }}
                </button>
            </div>
        </v-menu>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            required: true,
        },
        choices: {
            type: Array,
            required: true,
        },
    },
}
</script>
